import React from 'react';

import { useCampaignFilterInterface } from '@domain/campaigns/campaigns-filter/interface';
import { FIELD } from '../../../rules/rules.types';
import { CampaignSelector } from './campaigns-selector';
import { ValueSelector } from './value-selector';

export const ValueInputFactory = () => {
    const {
        field, isValueDisabled, onChangeValue, value, valueOptions,
    } = useCampaignFilterInterface();

    if (field?.value === FIELD.CAMPAIGNS) {
        return (
            <CampaignSelector
                onChange={onChangeValue}
                isDisabled={isValueDisabled}
            />
        );
    }

    return (
        <ValueSelector
            isDisabled={isValueDisabled}
            onChange={onChangeValue}
            value={value}
            options={valueOptions}
        />
    );
};
